/**
 * Shared simulated progress for image generation (~50s typical).
 * Backend/stream percent is a floor only — simulated progress keeps advancing
 * between sparse backend updates.
 */

export function getSimulatedGenerationProgress(
  elapsedSeconds: number,
  backendFloor = 0,
): { percent: number; label: string } {
  let simulated: number
  let label: string

  if (elapsedSeconds < 3) {
    simulated = (elapsedSeconds / 3) * 12
    label = "Getting ready..."
  } else if (elapsedSeconds < 8) {
    simulated = 12 + ((elapsedSeconds - 3) / 5) * 16
    label = "Preparing your scene..."
  } else if (elapsedSeconds < 38) {
    simulated = 28 + ((elapsedSeconds - 8) / 30) * 54
    label = "Creating your images..."
  } else if (elapsedSeconds < 50) {
    simulated = 82 + ((elapsedSeconds - 38) / 12) * 10
    label = "Almost done..."
  } else {
    simulated = 92 + Math.min(2, ((elapsedSeconds - 50) / 20) * 2)
    label = "Finishing up..."
  }

  const floor = Math.min(95, Math.max(0, backendFloor))
  const percent = Math.round(Math.min(94, Math.max(simulated, floor)))

  if (floor >= 85) label = "Almost done..."
  else if (floor >= 40 && percent >= 40) label = "Creating your images..."

  return { percent, label }
}

/** Labels used on `/generate/image` status row. */
export function getGenerateFeedProgressLabel(
  elapsedSeconds: number,
  percent: number,
  backendFloor: number,
): string {
  if (backendFloor >= 88 || percent >= 88) return "Finalizing..."
  if (elapsedSeconds >= 8 || percent >= 28) return "Creating your images..."
  return "Getting ready..."
}
